// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectQueryResult, selectInteractionTypesPageLoading, selectInteractionTypesShowInitWaitingMessage} from '../_selectors/interaction-type.selectors';

export class InteractionTypesDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectInteractionTypesPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectInteractionTypesShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
